
import React from 'react';

export const LogoIcon = () => (
  <svg style={{ width: '38px', height: '38px', flexShrink: 0 }} width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6030_1255)">
      <mask id="mask0_6030_1255" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="5" y="3" width="30" height="34">
        <path d="M5.19629 3.41187H34.1619V36.3435H5.19629V3.41187Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6030_1255)">
        <path fillRule="evenodd" clipRule="evenodd" d="M19.6791 33.6547C19.0343 33.5743 18.1207 33.2519 17.5563 33.0099C16.0787 32.4183 14.6815 31.5583 13.4723 30.5099C9.22709 26.7731 7.88349 21.1543 7.88349 15.6703V6.10027H19.6791V33.6547ZM5.19629 3.41187V15.6707C5.19629 33.7627 18.6043 36.3435 19.6791 36.3435C20.7539 36.3435 34.1619 33.7627 34.1619 15.6707C34.1619 13.7619 34.1619 5.29347 34.1619 3.41187H5.19629Z" fill="#9F7944" />
      </g>
      <path d="M13.7241 15.9084C13.0561 15.9084 12.4769 15.7788 11.9865 15.5196C11.4969 15.2604 11.1185 14.8892 10.8521 14.406C10.5853 13.9228 10.4521 13.3468 10.4521 12.678V8.2876H12.6057V12.5404C12.6057 13.4428 12.9785 13.894 13.7241 13.894C14.4705 13.894 14.8441 13.4428 14.8441 12.5404V8.2876H16.9865V12.678C16.9865 13.3468 16.8545 13.9228 16.5913 14.406C16.3289 14.8892 15.9537 15.2604 15.4665 15.5196C14.9801 15.7788 14.3993 15.9084 13.7241 15.9084Z" fill="#9F7944" />
      <mask id="mask1_6030_1255" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="24" y="17" width="6" height="5">
        <path d="M24.7822 17.3989H29.1854V21.4017H24.7822V17.3989Z" fill="white" />
      </mask>
      <g mask="url(#mask1_6030_1255)">
        <path d="M26.9509 17.3992L27.6109 18.7136L29.0873 18.9244L28.0193 19.9476L28.2713 21.3924L26.9509 20.71L25.6305 21.3924L25.8825 19.9476L24.8145 18.9244L26.2909 18.7136L26.9509 17.3992Z" fill="white" />
      </g>
      <mask id="mask2_6030_1255" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="29" y="19" width="4" height="4">
        <path d="M29.5947 19.0464H32.9471V22.348H29.5947V19.0464Z" fill="white" />
      </mask>
      <g mask="url(#mask2_6030_1255)">
        <path d="M31.4651 19.144L31.8207 20.2236L32.9275 20.548L31.9923 21.214L32.0203 22.3484L31.0867 21.6804L29.9975 22.0572L30.3555 20.9784L29.6543 20.0768L30.8095 20.078L31.4651 19.144Z" fill="white" />
      </g>
      <mask id="mask3_6030_1255" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="20" y="19" width="5" height="4">
        <path d="M20.9561 19.0469H24.2709V22.3485H20.9561V19.0469Z" fill="white" />
      </mask>
      <g mask="url(#mask3_6030_1255)">
        <path d="M22.437 19.1438L22.0814 20.2234L20.9746 20.5478L21.9098 21.2138L21.8814 22.3482L22.8154 21.6802L23.9046 22.057L23.5462 20.9782L24.2478 20.0766L23.0926 20.0778L22.437 19.1438Z" fill="white" />
      </g>
      <path d="M26.0292 15.4623V9.99346H23.7588V8.00146H30.442V9.99346H28.1716V15.4623H26.0292Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_6030_1255">
        <rect width="38.4" height="38.4" fill="white" transform="translate(0.513672 0.716797)" />
      </clipPath>
    </defs>
  </svg>
);
